import React from 'react';
import Sidebar from '../Sidebar';

const Contacts = () =>
{
    return(
        <div>
            <Sidebar/>
                <div className="App-Page">
                <h2>faulty.agatha(at)gmail.com </h2>
            </div>
        </div>    
    );
}

export default Contacts;